import { render, staticRenderFns } from "./HomeNewsTitle.vue?vue&type=template&id=1bf0933c&scoped=true&"
import script from "./HomeNewsTitle.vue?vue&type=script&lang=ts&"
export * from "./HomeNewsTitle.vue?vue&type=script&lang=ts&"
import style0 from "./HomeNewsTitle.vue?vue&type=style&index=0&id=1bf0933c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf0933c",
  null
  
)

export default component.exports